import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'offcanvasLevelCheck',
  standalone: true
})
export class OffcanvasLevelCheckPipe implements PipeTransform {
  transform(id: string, level: number, currHighest:number): unknown {
    return currHighest >= level;
  }

}
